import { render, staticRenderFns } from "./dangVR.vue?vue&type=template&id=7a2fc42c&scoped=true"
var script = {}
import style0 from "./dangVR.vue?vue&type=style&index=0&id=7a2fc42c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2fc42c",
  null
  
)

export default component.exports